import React, { useEffect, useState, useRef } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';

const Footer = () => {
    const targets = {
        linkedin: 2000,
        twitter: 980,
        youtube: 2100,
    };

    const [counts, setCounts] = useState({
        linkedin: 0,
        twitter: 0,
        youtube: 0,
    });

    const counterRef = useRef(null);
    const intervalRef = useRef(null);
    const lastVisibleRef = useRef(false);

    const startCounter = () => {
        clearInterval(intervalRef.current);
        setCounts({ linkedin: 0, twitter: 0, youtube: 0 });

        let current = { linkedin: 0, twitter: 0, youtube: 0 };
        const duration = 2000;
        const steps = duration / 50;
        const increment = {
            linkedin: targets.linkedin / steps,
            twitter: targets.twitter / steps,
            youtube: targets.youtube / steps,
        };

        intervalRef.current = setInterval(() => {
            current.linkedin += increment.linkedin;
            current.twitter += increment.twitter;
            current.youtube += increment.youtube;

            setCounts({
                linkedin: Math.min(Math.floor(current.linkedin), targets.linkedin),
                twitter: Math.min(Math.floor(current.twitter), targets.twitter),
                youtube: Math.min(Math.floor(current.youtube), targets.youtube),
            });

            if (
                current.linkedin >= targets.linkedin &&
                current.twitter >= targets.twitter &&
                current.youtube >= targets.youtube
            ) {
                clearInterval(intervalRef.current);
            }
        }, 50);
    };


    useEffect(() => {
        const handleScroll = () => {
            if (!counterRef.current) return;
            const rect = counterRef.current.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

            if (isVisible && !lastVisibleRef.current) {
                startCounter();
            }

            lastVisibleRef.current = isVisible;
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            clearInterval(intervalRef.current);
        };
    }, []);

    const handleSubscribe = (e) => {
        e.preventDefault();
        alert('Thank you for subscribing!');
    };

    return (
        <>
            <div className="top-container container-fluid">
            <Link to="https://newsletter.rispostaglobal.com/register" className="clickable-text" aria-label="Register and subscribe">
                <span style={{ fontSize: "18px", textDecoration: "none" }} className="newsletter_text">
                    Get our latest Newsletter
                </span>
                <button className="footerbutton" type="button" style={{ marginLeft: 8 }}>
                    Register
                </button>
            </Link>
        </div>
            <footer className="footer-wrapper">
                <div className="page-links">
                    <Link to="/about" className="footer-link">About Us</Link>
                    <Link to="/leadership" className="footer-link">Leadership</Link>
                    <Link to="/culture" className="footer-link">Culture</Link>
                    <Link to="/Career" className="footer-link">Careers</Link>
                    <Link to="/newsandevents" className="footer-link">News and Events</Link>
                    <Link to="/contactus" className="footer-link">Contact</Link>
                </div>

                <div className="social-icons" ref={counterRef}>
                    <div className="icon-with-count">
                        <a href="https://linkedin.com" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                            <FaLinkedin />
                        </a>
                        <div>{counts.linkedin.toLocaleString()} followers</div>
                    </div>
                </div>

                <div className="footer-bottom">
                    &copy; {new Date().getFullYear()} Blukraft® Global Services Pvt. Ltd. . All rights reserved.
                </div>
            </footer>
        </>
    );
};



export default Footer;
